import { FormGroup, Label, Col, Input, FormFeedback } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import React from 'react'

const FieldInput = ({ title, value, className = null, type = 'text', name, onChange, disabled = false, error }) => (
  <FormGroup row>
    <Col sm='4' className={className}>
      <Label>{I18n.t(title)}</Label>
    </Col>

    <Col sm='8'>
      <Input
        bsSize='sm'
        placeholder={I18n.t(title)}
        type={type}
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        invalid={error}
      />

      <FormFeedback>{error ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
    </Col>
  </FormGroup>
)

export default FieldInput
